module.exports = __webpack_public_path__ + "media/assets/back-icon-mask-fae3c934.png";